const PALETTE = ["#0F1115", "#059669", "#2D3142", "#7A5C3E", "#3C5A6E", "#6B7280", "#8B5E3C", "#1F6F5C", "#4B5563", "#0E4F3B"];

function hashCode(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = (hash << 5) - hash + str.charCodeAt(i);
  return Math.abs(hash);
}

function getInitials(name) {
  const words = name.replace(/[^a-zA-Z0-9À-ÿ ]/g, "").split(" ").filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function pickUniqueLogoBanks(banks) {
  const eligible = new Set();
  for (const b of banks || []) eligible.add(b.id || b.name);
  return eligible;
}

export const BankAvatar = ({ name, size = 36 }) => {
  const color = PALETTE[hashCode(name) % PALETTE.length];
  const testId = `bank-avatar-${name.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <div
      data-testid={testId}
      style={{ width: size, height: size, backgroundColor: color, fontSize: size * 0.32 }}
      className="flex items-center justify-center text-white font-display font-bold shrink-0"
    >
      {getInitials(name)}
    </div>
  );
};
